import { useState, useEffect, useRef } from 'react';
import { PORTFOLIO } from '../data';
import Magnetic from './Magnetic';
import './Contact.css';

function Contact() {
  const [copied, setCopied] = useState(false);
  const copiedTimeoutRef = useRef(null);

  useEffect(() => () => clearTimeout(copiedTimeoutRef.current), []);

  const copyEmail = () => {
    navigator.clipboard.writeText(PORTFOLIO.email);
    setCopied(true);
    clearTimeout(copiedTimeoutRef.current);
    copiedTimeoutRef.current = setTimeout(() => setCopied(false), 1500);
  };

  return (
    <section id="contact" className="section section--contact">
      <div className="contact">
        <h2 className="contact__heading" data-reveal>
          Let's connect.
        </h2>

        <div className="contact__email-row" data-reveal style={{ '--d': '0.15s' }}>
          <a href={`mailto:${PORTFOLIO.email}`} className="contact__email">
            {PORTFOLIO.email}
          </a>
          <button
            className="contact__copy"
            onClick={copyEmail}
            aria-label="Copy email to clipboard"
          >
            {copied ? (
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <polyline points="20 6 9 17 4 12" />
              </svg>
            ) : (
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
              </svg>
            )}
          </button>
          <span className="contact__copied" role="status" aria-live="polite">
            {copied ? 'Copied!' : ''}
          </span>
        </div>

        <a
          href={`tel:${PORTFOLIO.phone.replace(/\D/g, '')}`}
          className="contact__phone"
          data-reveal
          style={{ '--d': '0.22s' }}
        >
          {PORTFOLIO.phone}
        </a>

        <div className="contact__social" data-reveal style={{ '--d': '0.3s' }}>
          <Magnetic>
            <a
              href={PORTFOLIO.links.github}
              target="_blank"
              rel="noopener noreferrer"
              className="pill pill--link"
            >
              GitHub
            </a>
          </Magnetic>
          <Magnetic>
            <a
              href={PORTFOLIO.links.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="pill pill--link"
            >
              LinkedIn
            </a>
          </Magnetic>
        </div>
      </div>
    </section>
  );
}

export default Contact;
